<script>
import { useClientStore } from "@/store/client";
import { mapState } from "pinia";
import { email, required } from "@vuelidate/validators";
import ActivateMalinCardForm from "@/containers/activation-carte";
import Connexion from "@/containers/connexion";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Button from "@/components/atoms/button";
import {formValidationProps, useFormValidation} from "@/components/organisms/mixins/form-validation.mixin";

export default {
  name: "ActivationCarte",
  components: {
    Connexion,
    ActivateMalinCardForm,
    Button,
    GridRow,
    GridCol
  },
  props: {...formValidationProps()},
  setup(props) {
    const {
      v$
    } = useFormValidation(props)
    return {
      v$
    };
  },
  computed: {
    ...mapState(useClientStore, ["client"])
  },
  data() {
    return {
      email: "",
      emailValidated: false
    };
  },
  methods: {
    validate() {
      this.emailValidated = true;
    }
  },
  validations() {
    return {
      email: {
        required,
        email
      }
    }
  }
};
</script>

<template>
  <div class="u-bgcolor-white">
    <template v-if="client == null && !emailValidated">
      <br />
      <GridRow>
        <GridCol>
          <Connexion
            :popin="false"
            :display-create-account="false"
          />
        </GridCol>
        <GridCol>
          <div class="u-flex-column">
            <h1 class="c-connexion-form__title">
              Je n'ai pas encore de compte personnel,<br />
              je crée mon compte personnel
            </h1>
            <br />

            <div class="u-text-center u-mt-md u-pb-xlg">
              <Button
                variant="secondary"
                radius="full"
                class="c-connexion-form__button-connexion u-text-center"
                size="md"
                to="/creation-compte"
              >
                Je crée mon compte
              </Button>
            </div>
          </div>
        </GridCol>
      </GridRow>
    </template>
    <template v-else>
      <ActivateMalinCardForm :email-client="email" />
    </template>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/connexion-form.scss";
@import "@/assets/styles/components/inscription-form.scss";
</style>
